import FormRegisterStaff from "../../../components/FormRegisterStaff";
import Layout from "../../../components/Layout";
import Title from "../../../components/Title";

export default function RegisterStaff() {
    return (
        <Layout>
            <section className="w-full h-fit lg:h-fit py-[60px] px-[20px] text-center bg-[#f9f9f9]">
                <Title title="Đăng Ký Nhân Viên" subTitle="Điền thông tin để đăng ký" />
                <div className="max-w-[800px] h-fit mx-auto shadow-default bg-white rounded-[8px] mt-[40px] lg:p-[30px] lg:pb-[50px] p-[30px]">
                    <FormRegisterStaff />
                </div>
            </section>
        </Layout>
    )
}